export const getUsageActivityFeedColumnOptions = (
  hasBillingPermission: boolean,
): ReadonlyArray<{
  id: string;
  label: string;
  required?: boolean;
  mandatory?: boolean;
}> => [
  { id: "started_at", label: "Opened", required: true, mandatory: true },
  { id: "classification", label: "Type", required: true },
  { id: "finished_at", label: "Closed" },
  { id: "claim_number", label: "Claim ID" },
  { id: "payer", label: "Payer" },
  { id: "user", label: "Owner" },
  { id: "billed_amount", label: "Billed" },
  { id: "paid_amount", label: "Paid" },
  // Success Fee / Recovered live in the per-claim table (REV-1824), not the
  // per-case feed — a claim with several appeal chats would double-count them.
  ...(hasBillingPermission ? [{ id: "cost", label: "Base Fee" }] : []),
  { id: "has_837", label: "837s" },
  { id: "count_835", label: "835s" },
  { id: "count_document_uploads", label: "Docs" },
  { id: "successful_run", label: "Status" },
  { id: "chat_id", label: "Case ID" },
];
